/**
 * @license lucide v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const ClockAlert = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M12 6v6l4 2" }],
    ["path", { d: "M16 21.16a10 10 0 1 1 5-13.516" }],
    ["path", { d: "M20 11.5v6" }],
    ["path", { d: "M20 21.5h.01" }]
  ]
];

export { ClockAlert as default };
//# sourceMappingURL=clock-alert.js.map
